import { render, staticRenderFns } from "./EvidencesManager.vue?vue&type=template&id=1724fbae&"
import script from "./EvidencesManager.vue?vue&type=script&lang=ts&"
export * from "./EvidencesManager.vue?vue&type=script&lang=ts&"
import style0 from "./EvidencesManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports